<template>
  <resume-list :filters="filters"></resume-list>
</template>
<script>
  import ResumeList from 'src/views/admin/talent/resumes/ResumeList'

  export default {
    components: {
      ResumeList
    },
    computed: {
      filters() {
        return [
          {
            key: 'with',
            value: 'candidate.candidate.user,job'
          },
          {
            key: 'sort',
            value: '+created_at'
          },
          {
            key: 'match[candidate_uuid]',
            value: this.$route.params.id,
          }
        ]
      }
    }
  }
</script>
<style>
</style>
